import React from 'react';
import { shape, string } from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import TextBox from '@components/TextBox/TextBox';
import ImportImages from '@src/importImages';

const Logo1a = ImportImages('/safety/safety-1a.png');
const Logo1b = ImportImages('/safety/safety-1b.png');
const Logo1c = ImportImages('/safety/safety-1c.png');
const Logo2a = ImportImages('/safety/safety-2a.png');
const Logo2b = ImportImages('/safety/safety-2b.png');
const Logo2c = ImportImages('/safety/safety-2c.png');
const Logo3a = ImportImages('/safety/safety-3a.png');
const Logo3b = ImportImages('/safety/safety-3b.png');
const Logo3c = ImportImages('/safety/safety-3c.png');
const clouds = ImportImages('/home/clouds.jpg');

const propTypes = {
  id: string.isRequired,
  ratingProps: shape({
    header: string.isRequired,
    content: string.isRequired
  }).isRequired
};

const Desktop = ({ id, ratingProps, heightSm }) => (
  <div
    id={id}
    className={'panel d-flex align-items-center'}
    style={{ height: `${window.innerHeight}px` }}
  >
    <img
      src={clouds}
      alt={'Slider1'}
      className={'img-fluid d-none d-md-block'}
    />
    <Container
      fluid={true}
      className={'abs-container d-flex align-items-center'}
    >
      <Row className={'justify-content-center'}>
        <Col md={10} xs={12}>
          <Row>
            <Col md={heightSm ? 7 : 6} xs={12}>
              <TextBox {...ratingProps} isHeader={true} />
            </Col>
            <Col
              md={heightSm ? 5 : 6}
              xs={12}
              className={'d-flex justify-content-center flex-column'}
            >
              <Row className={'pb-5 w-100 mx-auto'}>
                <Col>
                  <img
                    src={Logo1a}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
                <Col>
                  <img
                    src={Logo1b}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
                <Col>
                  <img
                    src={Logo1c}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
              </Row>
              <Row className={'pb-5 w-100 mx-auto'}>
                <Col>
                  <img
                    src={Logo2a}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
                <Col>
                  <img
                    src={Logo2b}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
                <Col>
                  <img
                    src={Logo2c}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
              </Row>
              <Row className={'w-100 mx-auto'}>
                <Col>
                  <img
                    src={Logo3a}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
                <Col>
                  <img
                    src={Logo3b}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
                <Col>
                  <img
                    src={Logo3c}
                    className={'img-fluid d-block mx-auto grayscale'}
                    alt={'Logo'}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </div>
);

Desktop.propTypes = propTypes;

export default Desktop;



// WEBPACK FOOTER //
// ./src/components/Safety/Rating/Desktop/Desktop.jsx